export enum ChartType {
  DTS = 'DTS',
  DAS = 'DAS',
  DoB = 'DoB'
}

export enum ButtonStyles {
  PrimaryBlue = 'PrimaryBlue',
  PrimaryOrange = 'PrimaryOrange',
  PrimaryGreen = 'PrimaryGreen',
  Secondary = 'Secondary',
  Tertiary = 'Tertiary',
  Details = 'Details'
}

export enum ButtonSize {
  Standard = 'Standard',
  Details = 'Details',
  Small = 'Small',
  Custom = 'Custom',
  NoPadding = 'NoPadding'
}

export enum ResetTypes {
  KpFilter = 'KpFilter',
  DateTimeFilter = 'DateTimeFilter',
  SwitchesFilter = 'SwitchesFilter'
}

export enum DateTimeFilterTypes {
  Live = 'Live',
  Last24 = 'Last24',
  DatePicker = 'DatePicker'
}

export enum ModalSize {
  sm = '500px',
  md = '600px',
  lg = '700px',
  xl = '1140px'
}

export enum AdminTemplateType {
  User = 'User',
  OrganizationUsers = 'OrganizationUsers',
  Location = 'Location',
  Cable = 'Cable',
  Documentation = 'Documentation',
  Project = 'Project',
  Organization = 'Organisation',
  DeleteProject = 'DeleteProject',
  DeleteOrganization = 'DeleteOrganisation',
  Alarm = 'Alarm',
  DeleteAlarm = 'DeleteAlarm'
}

export enum AdminModalState {
  New = 'New',
  Add = 'Add',
  Edit = 'Edit',
  Delete = 'Delete',
  Deleted = 'Deleted',
  DeletionFailed = 'DeletionFailed'
}

export enum ValidationMessages {
  Number = 'Please enter a valid number',
  String = 'Please enter text',
  Boolean = 'Please enter true or false',
  Required = 'This field is required',
  Email = 'Please enter a valid email'
}
